<template>
  <v-footer
    color="indigo"
    app
    absolute
  >
    <v-container
      fluid
      class="text-center text-md-left"
    >
      <v-row>
        <v-col
          cols="12"
          md="5"
          order=3
          order-md=1
        >
          <v-sheet color="indigo" class="mx-2">
            <h4 class="body-1 text-uppercase font-weight-medium text-muted indigo--text text--lighten-5">Абитуриент
              КузГТУ</h4>
            <v-divider class="divider indigo lighten-2 mx-auto mx-md-0"></v-divider>
            <p class="body-2 font-weight-regular indigo--text text--lighten-5">Электронная система подачи заявлений в
              приемную комиссию <br>«Кузбасского
              государственного технического университета имени Т.Ф.&nbsp;Горбачева»</p>
            <p class="body-2 indigo--text text--lighten-5 font-weight-regular">&copy; КузГТУ, {{ new
              Date().getFullYear() }}</p>
          </v-sheet>
        </v-col>
        <v-col
          cols="12"
          md="5"
          order=1
          order-md=2
        >
          <v-sheet color="indigo" class="mx-2">
            <h4
              class="body-1 text-uppercase font-weight-medium text-muted indigo--text text--lighten-5">
              Контакты приемной комиссии
            </h4>
            <v-divider class="divider indigo lighten-2 mx-auto mx-md-0"></v-divider>
            <div class="body-2 font-weight-regular indigo--text text--lighten-5">
              <p class="mb-1">
                650000, г. Кемерово, ул. Весенняя, 28

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <v-btn text icon color="indigo lighten-5" dark href="https://go.2gis.com/knv7p" target="_blank">
                        <v-icon dark size="18">{{mdiMapMarker}}</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>Посмотреть на карте</span>
                </v-tooltip>
              </p>
              <p class="mb-1">Справочная информация:
                <a class="font-weight-regular indigo--text text--lighten-5"
                   v-bind:href="'https://идувкузгту.рф'">идувкузгту.рф</a>
              </p>
              <p class="mb-1">Электронная почта:
                <a class="font-weight-regular indigo--text text--lighten-5"
                   v-bind:href="'mailto:abit@kuzstu.ru'">abit@kuzstu.ru</a>
              </p>
              <div class="mb-1">Телефон:
                <a class="font-weight-regular indigo--text text--lighten-5"
                   v-bind:href="'tel:+73842682424'">+7 (3842) 68-24-24, </a>
                <a class="font-weight-regular indigo--text text--lighten-5"
                   v-bind:href="'tel:+73842396961'">39-69-61, </a>
                <a class="font-weight-regular indigo--text text--lighten-5"
                   v-bind:href="'tel:+79230312468'">8 923 031-24-68, </a>
                <a class="font-weight-regular indigo--text text--lighten-5"
                   v-bind:href="'tel:+79230307541'">8 923 030-75-41</a>
              </div>
            </div>
          </v-sheet>
        </v-col>
        <v-col
          cols="12"
          md="2"
          order=2
          order-md=3
        >
          <h4
            class="body-1 text-uppercase font-weight-medium text-muted indigo--text text--lighten-5">
            Социальные сети
          </h4>
          <v-divider class="divider indigo lighten-2 mx-auto mx-md-0"></v-divider>
          <p>
            <v-btn text icon color="indigo lighten-5" dark href="https://vk.com/news_kuzstu" target="_blank">
              <v-icon dark>{{mdiVk}}</v-icon>
            </v-btn>
            <v-btn text icon color="indigo lighten-5" dark href="https://twitter.com/rectorKuzSTU" target="_blank">
              <v-icon dark>{{mdiTwitter}}</v-icon>
            </v-btn>
            <v-btn text icon color="indigo lighten-5" dark
                   href="https://www.youtube.com/channel/UCL3YEvopoM5bNjCwBhApgEg" target="_blank">
              <v-icon dark>{{mdiYoutube}}</v-icon>
            </v-btn>
            <v-btn text icon color="indigo lighten-5" dark href="https://ok.ru/profile/568155442508" target="_blank">
              <v-icon dark>{{mdiOdnoklassniki}}</v-icon>
            </v-btn>
          </p>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  import {
    mdiFacebook,
    mdiInstagram,
    mdiMapMarker,
    mdiOdnoklassniki,
    mdiTwitter,
    mdiVk,
    mdiYoutube,
  } from '@mdi/js'

  export default {
    name: "Footer",
    data: () => ({
      mdiFacebook,
      mdiVk,
      mdiTwitter,
      mdiInstagram,
      mdiYoutube,
      mdiOdnoklassniki,
      mdiMapMarker,
    }),
  }
</script>

<style scoped>
  .divider {
    max-width: 60px;
    margin: .5rem 0;
  }
</style>
